module.exports = __webpack_public_path__ + "img/17839_L.94b6abc7.png";